import { Box, Button, TextField, Typography, CircularProgress } from '@mui/material'

const EMPTY_VALUES = {
  dn_reference: '',
  tpn_number: '',
  invoice_number: '',
}

const ShipmentReferenceFields = ({
  values = EMPTY_VALUES,
  onChange,
  disabled = false,
  onSave,
  saving = false,
  saveLabel = 'Save',
  showHeading = false,
  heading = 'Delivery & invoice numbers',
  description,
}) => {
  const handleFieldChange = (field) => (e) => {
    onChange?.({
      ...values,
      [field]: e.target.value,
    })
  }

  return (
    <Box>
      {showHeading && (
        <>
          <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {heading}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
              {description}
            </Typography>
          )}
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 2,
          alignItems: 'center',
        }}
      >
        <TextField
          label="DN number"
          placeholder="Optional"
          value={values.dn_reference ?? ''}
          onChange={handleFieldChange('dn_reference')}
          disabled={disabled || saving}
          size="small"
          sx={{ flex: '1 1 0', minWidth: { xs: '100%', sm: 140 } }}
        />
        <TextField
          label="TPN number"
          placeholder="Optional"
          value={values.tpn_number ?? ''}
          onChange={handleFieldChange('tpn_number')}
          disabled={disabled || saving}
          size="small"
          sx={{ flex: '1 1 0', minWidth: { xs: '100%', sm: 140 } }}
        />
        <TextField
          label="Invoice number"
          placeholder="Optional"
          value={values.invoice_number ?? ''}
          onChange={handleFieldChange('invoice_number')}
          disabled={disabled || saving}
          size="small"
          sx={{ flex: '1 1 0', minWidth: { xs: '100%', sm: 140 } }}
        />
        {onSave && (
          <Button
            variant="contained"
            size="small"
            onClick={onSave}
            disabled={disabled || saving}
            startIcon={saving ? <CircularProgress size={16} /> : null}
            sx={{
              bgcolor: '#11809A',
              '&:hover': { bgcolor: '#0f6d82' },
              minWidth: 100,
              flexShrink: 0,
            }}
          >
            {saving ? 'Saving...' : saveLabel}
          </Button>
        )}
      </Box>
    </Box>
  )
}

export const shipmentReferenceValuesFromShipment = (shipment) => ({
  dn_reference: shipment?.dn_reference ? String(shipment.dn_reference) : '',
  tpn_number: shipment?.tpn_number ? String(shipment.tpn_number) : '',
  invoice_number: shipment?.invoice_number ? String(shipment.invoice_number) : '',
})

export const shipmentReferencePayload = (values) => ({
  dn_reference: values.dn_reference?.trim() || null,
  tpn_number: values.tpn_number?.trim() || null,
  invoice_number: values.invoice_number?.trim() || null,
})

export default ShipmentReferenceFields
